import { resetInStoreProductForm } from '../selectors/instoreProductSelector';

const inStoreProduct = {
    hasInitialized: false,
    isLoading: {
        list: false,
        category: false,
        newCategoryForm: false,
        removeCategoryForm: false,
        detailForm: false,
        detailFormSubmit: false,
    },
    list: {},
    listDisplay: [],
    listParams: {
        filters: {},
        activePage: 1,
        perPage: 24,
        totalRecords: 1,
        sortBy: 'Title',
        sortDirection: 'ASC',
    },
    viewType: 'grid',
    detailForm: resetInStoreProductForm(),
    filterForm: {
        selectedCategory: '',
    },
    newCategoryForm: {
        categoryName: '',
    },
    removeCategoryForm: {
        selectedCategory: '',
    },
    categoryList: {},
    selected: {},
    allCheckboxesSelected: false,
};
const InStoreProductReducer = function(state = inStoreProduct, action) {
    switch (action.type) {
        case 'UPDATE_IN_STORE_PRODUCT_LIST_HAS_INITIALIZED': {
            return {
                ...state,
                hasInitialized: action.value,
            };
        }
        case 'TOGGLE_IN_STORE_PRODUCT_LOADING': {
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [action.key]: action.value,
                },
            };
        }
        case 'REPLACE_IN_STORE_CATEGORIES': {
            return {
                ...state,
                categoryList: action.value,
            };
        }
        case 'UPDATE_IN_STORE_PRODUCT_LIST': {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...action.value,
                },
            };
        }
        case 'UPDATE_IN_STORE_PRODUCT_LIST_DISPLAY': {
            return {
                ...state,
                listDisplay: action.value,
            };
        }
        case 'REPLACE_IN_STORE_CATEGORY_LIST': {
            return {
                ...state,
                categoryList: action.value,
            };
        }
        case 'REPLACE_IN_STORE_SELECTED_ROWS': {
            return {
                ...state,
                selected: action.value,
            };
        }
        case 'UPDATE_IN_STORE_SELECTED_ROW': {
            return {
                ...state,
                selected: {
                    ...state.selected,
                    [action.key]: action.value,
                },
            };
        }
        case 'RESET_IN_STORE_SELECTED_ROWS': {
            return {
                ...state,
                selected: {},
            };
        }
        case 'UPDATE_IN_STORE_ALL_ROWS_CHECKBOX': {
            return {
                ...state,
                allCheckboxesSelected: action.value,
            };
        }
        case 'UPDATE_IN_STORE_PRODUCT_LIST_VIEW_TYPE': {
            return {
                ...state,
                viewType: action.value,
            };
        }
        case 'UPDATE_IN_STORE_PRODUCT_LIST_FILTERS': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    filters: action.value,
                },
            };
        }
        case 'SET_IN_STORE_PRODUCT_LIST_SORT': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    sortBy: action.value,
                    sortDirection: action.direction,
                },
            };
        }
        case 'SET_IN_STORE_PRODUCT_LIST_ACTIVE_PAGE': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    activePage: action.value,
                },
            };
        }
        case 'SET_IN_STORE_PRODUCT_LIST_TOTAL_RECORDS': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    totalRecords: action.value,
                },
            };
        }
        case 'UPDATE_IN_STORE_PRODUCT_FILTER_FORM_DATA': {
            return {
                ...state,
                filterForm: {
                    ...state.filterForm,
                    [action.key]: action.value,
                },
            };
        }
        case 'UPDATE_IN_STORE_PRODUCT_NEW_CATEGORY_FORM_DATA': {
            return {
                ...state,
                newCategoryForm: {
                    ...state.newCategoryForm,
                    [action.key]: action.value,
                },
            };
        }
        case 'UPDATE_IN_STORE_PRODUCT_REMOVE_CATEGORY_FORM_DATA': {
            return {
                ...state,
                removeCategoryForm: {
                    ...state.removeCategoryForm,
                    [action.key]: action.value,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default InStoreProductReducer;
